const dayjs = require('dayjs')
// 防抖
export function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

// 通过dayjs格式化日期
// *
// * @param date 日期
// * @param fmt 格式,如:YYYY-MM-DD HH:mm:ss
// * @returns
export function formatDate(date, fmt) {
  return dayjs(date).format(fmt)
}

/**
 * 根据value获取label
 * @param {*} list
 * @param {*} value
 */
export function getLabelByValue(list, value) {
  let label = ''
  list.forEach(item => {
    if (item.dictValue == value) {
      label = item.dictLabel
    }
  })
  return label
}
export function numberToChinese(num) {
  const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const chineseUnits = ['', '十', '百', '千', '万', '十', '百', '千', '亿'];

  if (typeof num !== 'number' || !Number.isInteger(num) || num < 0) {
      return num;
  }

  if (num === 0) return chineseNumbers[0];

  let result = '';
  let str = num.toString();

  for (let i = 0; i < str.length; i++) {
      const digit = parseInt(str[i]);
      const unit = str.length - i - 1;

      if (digit === 0) {
          // 处理连续的零
          if (result[result.length - 1] !== chineseNumbers[0]) {
              result += chineseNumbers[digit];
          }
      } else {
          // 处理"一十"开头的简写为"十"
          if (!(i === 0 && digit === 1 && unit === 1)) {
              result += chineseNumbers[digit];
          }
          result += chineseUnits[unit];
      }
  }
  // 去除末尾的零
  if (result[result.length - 1] === chineseNumbers[0]) {
      result = result.slice(0, -1);
  }

  return result;
}
// 验证身份证并且长度为18位
export function validateIdCard(rule, value, callback){
  if (!value) {
    callback(new Error("请输入身份证号码"));
    return;
  }

  // 基本格式校验
  const reg =
    /^\d{6}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
  if (!reg.test(value)) {
    callback(new Error("身份证格式不正确"));
    return;
  }

  // 18位身份证需要校验最后一位校验码
  if (value.length === 18) {
    // 校验地区码（前6位）
    const areaCode = value.substring(0, 6);
    // 这里应该有完整的地区码列表，简化示例只检查前两位
    if (
      !/^(11|12|13|14|15|21|22|23|31|32|33|34|35|36|37|41|42|43|44|45|46|50|51|52|53|54|61|62|63|64|65|71|81|82)/.test(
        areaCode
      )
    ) {
      callback(new Error("身份证地区码不正确"));
      return;
    }

    // 校验生日
    const birthDate = value.substring(6, 14);
    const year = parseInt(birthDate.substring(0, 4));
    const month = parseInt(birthDate.substring(4, 6)) - 1;
    const day = parseInt(birthDate.substring(6, 8));
    const date = new Date(year, month, day);
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month ||
      date.getDate() !== day
    ) {
      callback(new Error("身份证生日无效"));
      return;
    }

    // 校验码验证
    const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const checkCodes = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
    let sum = 0;
    for (let i = 0; i < 17; i++) {
      sum += parseInt(value.charAt(i)) * weights[i];
    }
    const checkCode = checkCodes[sum % 11];
    if (checkCode !== value.charAt(17).toUpperCase()) {
      callback(new Error("身份证校验码不正确"));
      return;
    }
  }

  // 15位身份证需要校验生日
  if (value.length === 15) {
    const birthDate = "19" + value.substring(6, 12);
    const year = parseInt(birthDate.substring(0, 4));
    const month = parseInt(birthDate.substring(4, 6)) - 1;
    const day = parseInt(birthDate.substring(6, 8));
    const date = new Date(year, month, day);
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month ||
      date.getDate() !== day
    ) {
      callback(new Error("身份证生日无效"));
      return;
    }
  }

  callback();
};

/**
 * 检测浏览器类型
 * @returns {Object} 包含浏览器信息的对象
 */
export function detectBrowser() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  console.log('userAgent', userAgent);
  
  const browserInfo = {
    isEdge: false,
    isChrome: false,
    isFirefox: false,
    isSafari: false,
    isIE: false,
    isWeChat: false,
    browserName: '',
    browserVersion: '',
    isMobile: false,
    isTablet: false,
    isDesktop: false
  };

  // 检测微信浏览器（需要优先检测，因为微信浏览器也包含chrome字符串）
  if (userAgent.indexOf('micromessenger') > -1) {
    browserInfo.browserName = 'WeChat';
    browserInfo.isWeChat = true;
  }
  // 检测Edge浏览器（包括新版本基于Chromium的Edge）
  else if (userAgent.indexOf('edg') > -1 || userAgent.indexOf('edge') > -1) {
    browserInfo.isEdge = true;
    browserInfo.browserName = 'Edge';
  }
  // 检测Chrome浏览器（排除Edge和微信，因为新Edge和微信也包含chrome字符串）
  else if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('safari') > -1 && userAgent.indexOf('edg') === -1 && userAgent.indexOf('micromessenger') === -1) {
    browserInfo.isChrome = true;
    browserInfo.browserName = 'Chrome';
  }
  // 检测Firefox浏览器
  else if (userAgent.indexOf('firefox') > -1) {
    browserInfo.isFirefox = true;
    browserInfo.browserName = 'Firefox';
  }
  // 检测Safari浏览器（排除Chrome、Edge和微信）
  else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1 && userAgent.indexOf('edg') === -1 && userAgent.indexOf('micromessenger') === -1) {
    browserInfo.isSafari = true;
    browserInfo.browserName = 'Safari';
  }
  // 检测IE浏览器
  else if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
    browserInfo.isIE = true;
    browserInfo.browserName = 'Internet Explorer';
  }
  // 其他浏览器
  else {
    browserInfo.browserName = 'Unknown';
  }

  // 检测设备类型
  if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
    browserInfo.isMobile = true;
  } else if (/ipad|tablet/i.test(userAgent)) {
    browserInfo.isTablet = true;
  } else {
    browserInfo.isDesktop = true;
  }

  // 获取浏览器版本
  let versionMatch;
  
  if (browserInfo.isWeChat) {
    // 微信浏览器版本检测
    versionMatch = userAgent.match(/micromessenger\/(\d+)/i);
  } else if (browserInfo.isEdge) {
    // Edge版本检测
    versionMatch = userAgent.match(/edg\/(\d+)/i) || userAgent.match(/edge\/(\d+)/i);
  } else if (browserInfo.isChrome) {
    // Chrome版本检测
    versionMatch = userAgent.match(/chrome\/(\d+)/i);
  } else if (browserInfo.isFirefox) {
    // Firefox版本检测
    versionMatch = userAgent.match(/firefox\/(\d+)/i);
  } else if (browserInfo.isSafari) {
    // Safari版本检测
    versionMatch = userAgent.match(/version\/(\d+)/i);
  } else if (browserInfo.isIE) {
    // IE版本检测
    versionMatch = userAgent.match(/msie\s(\d+)/i) || userAgent.match(/rv:(\d+)/i);
  }
  
  if (versionMatch) {
    browserInfo.browserVersion = versionMatch[1];
  }

  return browserInfo;
}

/**
 * 检查是否为推荐的浏览器（Chrome或Edge）
 * @returns {boolean}
 */
export function isRecommendedBrowser() {
  const browserInfo = detectBrowser();
  
  // 使用多重检测方法，提高准确性
  const isRealChrome = isRealChromeBrowser();
  const isRealEdge = isRealEdgeBrowser();
  
  // 备选检测方法：如果主要检测失败，使用简化检测
  const fallbackChrome = isFallbackChromeDetection();
  
  console.log('浏览器检测结果:', {
    browserName: browserInfo.browserName,
    isChrome: browserInfo.isChrome,
    isEdge: browserInfo.isEdge,
    isWeChat: browserInfo.isWeChat,
    isRealChrome: isRealChrome,
    isRealEdge: isRealEdge,
    fallbackChrome: fallbackChrome,
    isRecommended: isRealChrome || isRealEdge || fallbackChrome,
    userAgent: window.navigator.userAgent
  });
  
  // 只有真正的Chrome和Edge浏览器才能通过校验
  return isRealChrome || isRealEdge || fallbackChrome;
}

/**
 * 调试函数：获取详细的Chrome检测信息
 * @returns {Object}
 */
export function debugChromeDetection() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  
  const debugInfo = {
    userAgent: window.navigator.userAgent,
    hasChrome: userAgent.indexOf('chrome') > -1,
    hasSafari: userAgent.indexOf('safari') > -1,
    hasEdge: userAgent.indexOf('edg') > -1,
    hasWeChat: userAgent.indexOf('micromessenger') > -1,
    hasLenovo: userAgent.indexOf('lenovobrowser') > -1 || userAgent.indexOf('lenovo') > -1,
    hasQQ: userAgent.indexOf('qqbrowser') > -1,
    hasUC: userAgent.indexOf('ucbrowser') > -1,
    has360: userAgent.indexOf('360browser') > -1 || userAgent.indexOf('qhbrowser') > -1,
    hasMaxthon: userAgent.indexOf('maxthon') > -1,
    hasSogou: userAgent.indexOf('metasr') > -1,
    hasOpera: userAgent.indexOf('opr') > -1 || userAgent.indexOf('opera') > -1,
    hasBrave: userAgent.indexOf('brave') > -1,
    hasChromeAPI: typeof window.chrome !== 'undefined',
    vendor: navigator.vendor,
    product: navigator.product,
    appName: navigator.appName,
    chromeVersion: userAgent.match(/chrome\/(\d+)/i)?.[1] || 'unknown',
    platform: navigator.platform,
    userAgentData: navigator.userAgentData || 'not supported',
    // 新增Mac检测信息
    isMac: /macintosh|mac os x/i.test(navigator.platform),
    navigatorPlatform: navigator.platform,
    // 检测结果
    mainDetection: isRealChromeBrowser(),
    fallbackDetection: isFallbackChromeDetection()
  };
  
  return debugInfo;
}

/**
 * 检测是否为真正的Chrome浏览器
 * @returns {boolean}
 */
function isRealChromeBrowser() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  
  // 1. 检查userAgent中的关键标识
  const hasChrome = userAgent.indexOf('chrome') > -1;
  const hasSafari = userAgent.indexOf('safari') > -1;
  const hasEdge = userAgent.indexOf('edg') > -1;
  const hasWeChat = userAgent.indexOf('micromessenger') > -1;
  const hasLenovo = userAgent.indexOf('lenovobrowser') > -1 || userAgent.indexOf('lenovo') > -1;
  const hasQQ = userAgent.indexOf('qqbrowser') > -1;
  const hasUC = userAgent.indexOf('ucbrowser') > -1;
  const has360 = userAgent.indexOf('360browser') > -1 || userAgent.indexOf('qhbrowser') > -1;
  const hasMaxthon = userAgent.indexOf('maxthon') > -1;
  const hasSogou = userAgent.indexOf('metasr') > -1;
  const hasOpera = userAgent.indexOf('opr') > -1 || userAgent.indexOf('opera') > -1;
  const hasBrave = userAgent.indexOf('brave') > -1;
  
  // 2. 检查Chrome特有的API（简化检查）
  const hasChromeAPI = typeof window.chrome !== 'undefined';
  
  // 3. 检查navigator属性（Mac和Windows的Chrome可能有不同的product值）
  const hasChromeNavigator = navigator.vendor === 'Google Inc.';
  
  // 4. 检查Chrome版本信息
  const chromeVersionMatch = userAgent.match(/chrome\/(\d+)/i);
  const hasValidChromeVersion = chromeVersionMatch && parseInt(chromeVersionMatch[1]) >= 50;
  
  // 5. 检查是否为真正的Chrome（排除所有已知的Chromium内核浏览器）
  const isRealChrome = hasChrome && 
                      hasSafari && 
                      !hasEdge && 
                      !hasWeChat && 
                      !hasLenovo && 
                      !hasQQ && 
                      !hasUC && 
                      !has360 && 
                      !hasMaxthon && 
                      !hasSogou &&
                      !hasOpera &&
                      !hasBrave &&
                      hasChromeAPI &&
                      hasChromeNavigator &&
                      hasValidChromeVersion;
  
  // // 调试信息
  // console.log('Chrome检测详情:', {
  //   hasChrome,
  //   hasSafari,
  //   hasEdge,
  //   hasWeChat,
  //   hasLenovo,
  //   hasQQ,
  //   hasUC,
  //   has360,
  //   hasMaxthon,
  //   hasSogou,
  //   hasOpera,
  //   hasBrave,
  //   hasChromeAPI,
  //   hasChromeNavigator,
  //   hasValidChromeVersion,
  //   vendor: navigator.vendor,
  //   product: navigator.product,
  //   appName: navigator.appName,
  //   chromeVersion: chromeVersionMatch?.[1],
  //   userAgent: window.navigator.userAgent,
  //   isRealChrome
  // });
  
  return isRealChrome;
}

/**
 * 备选Chrome检测方法（简化版）
 * @returns {boolean}
 */
function isFallbackChromeDetection() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  
  // 简化的Chrome检测逻辑
  const hasChrome = userAgent.indexOf('chrome') > -1;
  const hasSafari = userAgent.indexOf('safari') > -1;
  const hasEdge = userAgent.indexOf('edg') > -1;
  const hasWeChat = userAgent.indexOf('micromessenger') > -1;
  
  // 排除明显的非Chrome浏览器
  const isNotOtherBrowser = !hasEdge && !hasWeChat;
  
  // 检查Chrome API
  const hasChromeAPI = typeof window.chrome !== 'undefined';
  
  // 检查是否为Mac系统
  const isMac = /macintosh|mac os x/i.test(navigator.platform);
  
  // Mac上的Chrome检测（更宽松）
  if (isMac && hasChrome && hasSafari && isNotOtherBrowser && hasChromeAPI) {
    return true;
  }
  
  // Windows上的Chrome检测
  if (!isMac && hasChrome && hasSafari && isNotOtherBrowser && hasChromeAPI) {
    return true;
  }
  
  return false;
}

/**
 * 检测是否为真正的Edge浏览器
 * @returns {boolean}
 */
function isRealEdgeBrowser() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  
  // 1. 检查userAgent中的关键标识
  const hasEdge = userAgent.indexOf('edg') > -1;
  const hasChrome = userAgent.indexOf('chrome') > -1;
  const hasSafari = userAgent.indexOf('safari') > -1;
  
  // 2. 检查Edge特有的API
  const hasEdgeAPI = typeof window.navigator.msLaunchUri !== 'undefined' ||
                    (typeof window.chrome !== 'undefined' && 
                     typeof window.chrome.webstore === 'undefined' &&
                     typeof window.chrome.runtime === 'undefined');
  
  // 3. 检查是否为真正的Edge
  const isRealEdge = hasEdge && hasChrome && hasSafari && hasEdgeAPI;
  
  return isRealEdge;
}

/**
 * 检测是否为微信环境
 * @returns {boolean}
 */
export function isWeChatBrowser() {
  const browserInfo = detectBrowser();
  return browserInfo.isWeChat;
}

/**
 * 获取浏览器指纹信息，用于更精准的浏览器识别
 * @returns {Object}
 */
export function getBrowserFingerprint() {
  const fingerprint = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    cookieEnabled: navigator.cookieEnabled,
    doNotTrack: navigator.doNotTrack,
    hardwareConcurrency: navigator.hardwareConcurrency,
    maxTouchPoints: navigator.maxTouchPoints,
    vendor: navigator.vendor,
    product: navigator.product,
    appName: navigator.appName,
    appVersion: navigator.appVersion,
    // 检查各种浏览器特有的API
    hasChrome: typeof window.chrome !== 'undefined',
    hasEdge: typeof window.navigator.msLaunchUri !== 'undefined',
    hasFirefox: typeof window.InstallTrigger !== 'undefined',
    hasSafari: typeof window.safari !== 'undefined',
    hasIE: typeof window.ActiveXObject !== 'undefined',
    // 检查WebGL信息
    webglVendor: null,
    webglRenderer: null,
    // 检查Canvas指纹
    canvasFingerprint: null
  };
  
  try {
    // 获取WebGL信息
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (gl) {
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      if (debugInfo) {
        fingerprint.webglVendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
        fingerprint.webglRenderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      }
    }
    
    // 获取Canvas指纹
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Browser Fingerprint', 2, 2);
    fingerprint.canvasFingerprint = canvas.toDataURL();
  } catch (e) {
    // 忽略错误
  }
  
  return fingerprint;
}

/**
 * 获取浏览器兼容性提示信息
 * @returns {string}
 */
export function getBrowserCompatibilityMessage() {
  const browserInfo = detectBrowser();
  
  if (browserInfo.isChrome || browserInfo.isEdge) {
    return `当前使用 ${browserInfo.browserName} 浏览器，兼容性良好`;
  } else if (browserInfo.isWeChat) {
    return `当前使用微信内置浏览器，功能受限，请使用Chrome或Edge浏览器`;
  } else if (browserInfo.isFirefox || browserInfo.isSafari) {
    return `当前使用 ${browserInfo.browserName} 浏览器，建议使用Chrome或Edge获得最佳体验`;
  } else {
    return `当前浏览器可能不完全兼容，建议使用Chrome或Edge浏览器`;
  }
}

/**
 * 格式化消息文本，按序号换行
 * @param {string} message - 原始消息文本
 * @returns {string} - 格式化后的HTML文本
 */
export const formatMessageWithNumbers = (message) => {
  if (!message) return '';
  
  // 使用正则表达式匹配数字序号（如：1. 2. 3. 等）
  const formattedMessage = message.replace(/(\d+\.\s*)/g, '<br>$1');
  
  // 如果第一个字符是换行符，则移除
  return formattedMessage.startsWith('<br>') ? formattedMessage.substring(4) : formattedMessage;
};

/**
 * 格式化消息文本为数组，每个序号项为一个元素
 * @param {string} message - 原始消息文本
 * @returns {Array} - 格式化后的数组
 */
export const formatMessageToArray = (message) => {
  if (!message) return [];
  
  // 使用正则表达式分割文本，按数字序号分割
  return message.split(/(?=\d+\.\s*)/).filter(item => item.trim());
};

/**
 * 获取移动端安全的高度值，解决100vh在移动端的问题
 * @returns {number} 安全的高度值
 */
export function getMobileSafeHeight() {
  // 获取实际可视区域高度
  const actualHeight = window.innerHeight || document.documentElement.clientHeight;
  
  // 在移动端，使用实际高度
  if (isMobileDevice()) {
    return actualHeight;
  }
  
  // 在桌面端，使用100vh
  return window.innerHeight;
}

/**
 * 检测是否为移动设备
 * @returns {boolean}
 */
export function isMobileDevice() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
}

/**
 * 检测是否为平板设备
 * @returns {boolean}
 */
export function isTabletDevice() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /ipad|tablet/i.test(userAgent);
}

/**
 * 获取设备类型
 * @returns {string} 'mobile', 'tablet', 'desktop'
 */
export function getDeviceType() {
  if (isMobileDevice()) {
    return 'mobile';
  } else if (isTabletDevice()) {
    return 'tablet';
  } else {
    return 'desktop';
  }
}

